import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select, { components } from 'react-select';
import styledComponent from '../../utils/styledComponent';
import FilterClearButton from './FilterClearButton';
// eslint-disable-next-line import/no-cycle
import { BASE_STATUSES } from './ViewFridgeSoftware';
import { sortArrayOfObjects } from './Utilities/ViewFridgeSoftware_utilities';

/*     STYLED COMPONENT     */

const StyledDiv = styledComponent('div', {
  '&.filterRow': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  '&.footerWrapper': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
});

/*     Checkbox to be used in Select     */

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

/*     FILTERMODAL COMPONENT     */

const FilterModal = (props) => {
  /*     STATE VARIABLES     */

  const [shownVersions, setShownVersions] = useState([]);

  /*     FUNCTIONS     */

  const handleClick = (event) => {
    const temp = {
      ...props.statuses,
      [event.target.id]: !props.statuses[event.target.id],
    };
    props.updateStatuses(temp);
  };

  const updateFilter = (newMessage) => {
    // Parameter should be set to null if reset filters
    if (!newMessage) {
      props.updateStatuses({ ...BASE_STATUSES });
      changeSoftwareDisplay({}, null);
      changePilotDisplay(null);
    }

    // Used right now to revert back to state prior to opening modal
    else {
      props.updateStatuses(newMessage.statuses);
      changeSoftwareDisplay(
        newMessage.selectedSoftware,
        newMessage.selectedVersions,
      );
      changePilotDisplay(newMessage.selectedPilot);
    }
  };

  // When software has been selected from software dropdown
  const changeSoftwareDisplay = (newSoftware, newVersions) => {
    props.updateSelectedSoftware(newSoftware);
    props.updateSelectedVersions([]);
    if (newSoftware.versions) {
      const sortedVersions = sortArrayOfObjects(
        newSoftware.versions,
        'cleanName',
        'desc',
      );
      setShownVersions(
        sortedVersions.concat({ version: null, cleanName: 'No Version' }),
      );
    } else {
      setShownVersions([]);
    }

    if (newVersions) {
      props.updateSelectedVersions(newVersions);
    } else {
      props.updateSelectedVersions([]);
    }
  };

  // Controls pilot toolbar
  const changePilotDisplay = (newPilot) => {
    if (newPilot) {
      props.updateSelectedPilot(newPilot);
    } else {
      props.updateSelectedPilot({});
    }
  };

  return (
    <StyledDiv>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          style={{
            backgroundColor: '#D3EBC2',
            height: '80px',
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{
              width: '562px',
              height: '35px',
              fontWeight: '450px',
              fontSize: '28px',
              lineHeight: '35px',
            }}
          >
            Filter by
          </Modal.Title>
          <Button
            style={{
              backgroundColor: '#D3EBC2',
              border: 'none',
              hover: 'none',
              outline: 'none',
              boxShadow: 'none',
            }}
            onClick={() => {
              props.onHide();
              updateFilter(props.filterResponse);
            }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <h4
            style={{
              fontWeight: '550',
            }}
          >
            Status
          </h4>
          <div
            className="filterRow"
            style={{ display: 'flex', justifyContent: 'space-evenly' }}
          >
            <div className="checkboxWrapper">
              <div className="checkbox">
                <input
                  key={1}
                  type="checkbox"
                  id="LIVE"
                  onChange={handleClick}
                  checked={props.statuses.LIVE}
                />
              </div>
              <label htmlFor="LIVE" style={{ fontWeight: '500px' }}>
                Live
              </label>
            </div>
            <div className="checkboxWrapper">
              <div className="checkbox">
                <input
                  key={2}
                  type="checkbox"
                  id="DEAD"
                  onChange={handleClick}
                  checked={props.statuses.DEAD}
                />
              </div>
              <label htmlFor="DEAD">Dead</label>
            </div>
            <div className="checkboxWrapper">
              <div className="checkbox">
                <input
                  key={3}
                  type="checkbox"
                  id="OFFLINE"
                  onChange={handleClick}
                  checked={props.statuses.OFFLINE}
                />
              </div>
              <label htmlFor="OFFLINE">Offline</label>
            </div>
          </div>
          <h4
            style={{
              fontWeight: '550',
            }}
          >
            Version
          </h4>
          <div
            className="filterRow"
            style={{ display: 'flex', justifyContent: 'space-evenly' }}
          >
            <div className="dropdownWrapper">
              <p>Software</p>
              <div style={{ width: '240px' }}>
                <Select
                  options={props.softwareData}
                  getOptionLabel={(option) => option.artifactType}
                  onChange={(e) => {
                    changeSoftwareDisplay(e, null);
                  }}
                  value={
                    Object.keys(props.selectedSoftware).length
                      ? props.selectedSoftware
                      : null
                  }
                />
              </div>
            </div>
            <div className="dropdownWrapper">
              <p>Version</p>
              <Select
                options={shownVersions}
                isMulti
                isSearchable
                getOptionLabel={(option) => option.cleanName}
                getOptionValue={(option) => option.versionName}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option }}
                onChange={(e) => {
                  props.updateSelectedVersions(e);
                }}
                value={props.selectedVersions}
              />
            </div>
          </div>
          <h4
            style={{
              fontWeight: '550',
            }}
          >
            Pilot
          </h4>
          <div
            className="filterRow"
            style={{ display: 'flex', paddingLeft: '75px' }}
          >
            <Select
              options={props.pilotsData}
              getOptionLabel={(option) => option.displayName}
              onChange={(e) => {
                changePilotDisplay(e);
              }}
              value={
                Object.keys(props.selectedPilot).length
                  ? props.selectedPilot
                  : null
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div
            className="footerWrapper"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div className="buttonWrapper">
              <FilterClearButton clearFilter={updateFilter} display="flex" />
            </div>
            <div className="buttonWrapper">
              <Button
                onClick={() => {
                  props.onHide();
                  updateFilter(props.filterResponse);
                }}
                style={{ color: '#368007', border: 'none', outline: 'none' }}
              >
                CANCEL
              </Button>
              <Button
                onClick={() => {
                  props.onHide();
                  props.applyFilterResponse({
                    statuses: props.statuses,
                    selectedSoftware: props.selectedSoftware,
                    selectedVersions: props.selectedVersions,
                    selectedPilot: props.selectedPilot,
                  });
                }}
                style={{
                  color: '#FFFFFF',
                  border: 'none',
                  backgroundColor: '#368007',
                  outline: 'none',
                }}
              >
                APPLY
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </StyledDiv>
  );
};

export default FilterModal;
